const selector = {
    form: {
        main: '#form_tag_order',
    },
    checkTerms: '#check_terms_order',
    captcha: '#captcha',
    captchaHolder: '#captcha_holder_order',
    reloadCaptcha: '#reload_captcha_order',
    btn: {
        submit: '#btn_submit_order',
    },
    email: '#email',
    emailSendCodeBtn: '#send_verification_code_order',
    emailCode: '#email_verification_code_order',
};

export {selector};
